import { TierTooltipText } from "./constants";

export const getYear = () => {
  const date = new Date();
  return date.getFullYear();
};

export const yearArray = (start, end) => {
  let startYear = start ? start : 1990;
  let endYear = end ? end : getYear();
  let yearData = [];
  for (let i = startYear; i <= endYear; i++) {
    yearData[i] = {};
    yearData[i].label = i.toString(10);
    yearData[i].value = i.toString(10);
  }
  return yearData.reverse();
};

export const generateString = length => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const toTitleCase = str => {
  if (!str || str.length === 0) return "";
  str = (/[_&\\/#, +()$~%.'":*?<>{}-]/g).test(str) ? str.replaceAll(/[_&\\/#, +()$~%.'":*?<>{}-]/g, ' ') : str;
  return str.trim().split(' ').map(word => (
    word[0] ? word[0].toUpperCase() + word.substring(1).toLowerCase() : word + word.substring(1).toLowerCase()
  )).join(' ')
}

export const formatWebsite = website => {
  if (/(http(s?)):\/\//i.test(website)) return website;
  else return `https://${website}`;
}

export const formatNumber = value => {
  const numFormat = Intl.NumberFormat('en-US');
  numFormat.format(value);
  return numFormat.format(value);
};

export const checkSubdomainExists = url => {
  const regex = new RegExp(/(?:http[s]*:\/\/)*(.*?)\.(?=[^/]*\..{2,5})/i);
  return !!url.match(regex);
};

export const handleDynamicAuth = (fields, keys) => {
  let dynamicAuth = [];
  let emailIndex = keys.findIndex(each => each === 'email');
  if (emailIndex > -1) keys.splice(emailIndex, 1);
  for (let each of keys) {
    let findKeyElement = fields.find(eachKey => eachKey.key === each);
    if (findKeyElement) dynamicAuth.push(findKeyElement);
  }
  return dynamicAuth;
};

export const formatAmountToNumber = data => {
  const newData = data.replace(/[^0-9]/g, "");
  return Number(newData);
};

export const formatService = payloadData => {
  let newObj = {};
  for (let service of payloadData) {
    newObj = {...newObj, [service.reference]: true};
  }
  return newObj
};

export const formatAmountToString = data => {
  const format = !data ? "0.00" : data;
  if (format.toString() === "0.00") return format.toLocaleString();
  else if (format.toString().includes(",")) {
    const newFormat = format.toString().replace(/,/g, "");
    const formattedNumber = parseFloat(newFormat);
    return formattedNumber.toLocaleString();
  } else if (format.toString().includes(".")) {
    const formatValue = truncateDecimalValue(format);
    return formatValue.toLocaleString();
  } else return `${format.toLocaleString()}`;
};

export const truncateDecimalValue = value => {
  value = value.toString();
  const numberValue = value.split(".")[0];
  const suffixedNumber = value.split(".")[1].substring(0, 2);
  const decimalCount = value.split(".")[1].length;
  const prefixedNumber = Number(numberValue).toLocaleString();
  if (decimalCount > 2) value = `${prefixedNumber}.${suffixedNumber}`;
  else if (decimalCount < 2) value = `${prefixedNumber}.${suffixedNumber}0`;
  else value = suffixedNumber === "00" ? prefixedNumber : `${prefixedNumber}.${suffixedNumber}`;
  return value;
};

export const fileToBase64 = event => {
  let files;
  return new Promise(resolve => {
    if(event.dataTransfer) files = event.dataTransfer.files;
    else if(event.target) files = event.target.files;
    const reader = new FileReader();
    reader.onload = () => resolve(reader['result']);
    reader.readAsDataURL(files[0]);
  });
};

export const copyToClipboard = async (text) => {
  return await navigator.clipboard.writeText(text);
}

export const maskString = str => {  if (!str || str.length === 0) return "";  return str.replace(/\w/g, ".")}

const normalizeFieldText = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .replace(/[_&\\/#, +()$~%.'":*?<>{}-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const TIER_KEYWORDS = {
  TIER_1: [
    "phone",
    "phone no",
    "phone number",
    "mobile",
    "password",
  ],
  TIER_2: [
    "email",
    "e-mail",
    "house address",
    "home address",
    "residential address",
    "address",
    "street",
    "lga",
    "state",
    "utility",
    "nin",
    "national identification",
    "driver licence",
    "driver license",
    "drivers licence",
    "drivers license",
    "valid id",
    "identification",
  ],
  TIER_3: [
    "business",
    "owner",
    "cac",
    "vehicle",
    "plate",
    "tonnage",
    "color",
    "colour",
    "make",
    "hackney",
    "insurance",
    "road worthiness",
    "roadworthiness",
    "permit",
    "certificate",
    "vehicle document",
    "vehicle documents",
  ],
};

const resolveTierKey = (formControl) => {
  if (!formControl) return "TIER_1";
  const fieldText = normalizeFieldText(
    `${formControl.label || ""} ${formControl.key || ""} ${formControl.name || ""} ${formControl.placeholder || ""}`
  );
  if (!fieldText) return "TIER_1";

  const matches = (keywords) => keywords.some((keyword) => fieldText.includes(keyword));

  if (matches(TIER_KEYWORDS.TIER_3)) return "TIER_3";
  if (matches(TIER_KEYWORDS.TIER_2)) return "TIER_2";
  if (matches(TIER_KEYWORDS.TIER_1)) return "TIER_1";
  return "TIER_1";
};

export const getTierTooltip = (formControl) => {
  const tierKey = resolveTierKey(formControl);
  return TierTooltipText[tierKey] || TierTooltipText.TIER_1;
};

export const getTierKey = (formControl) => resolveTierKey(formControl);

const ADDRESS_KEYWORDS = [
  "MAIN",
  "ROAD",
  "RD",
  "STREET",
  "ST",
  "AVENUE",
  "AVE",
  "LANE",
  "CLOSE",
  "DRIVE",
  "WAY",
  "MARKET",
  "OVERPASS",
  "BRIDGE",
  "PHASE",
  "ESTATE",
  "PEDESTRIAN",
  "CRESCENT",
  "PLAZA",
  "TERMINAL",
  "AJAO"
];

export const formatAddress = (addr = "") => {
  if (!addr) return "";

  const needsAggressiveSpacing = (segment) =>
    /^[A-Z0-9]+$/.test(segment.replace(/\s+/g, ""));

  const addKeywordSpacing = (segment) => {
    if (!needsAggressiveSpacing(segment)) return segment;
    let value = segment;
    ADDRESS_KEYWORDS.forEach((keyword) => {
      const regex = new RegExp(`(${keyword})`, "ig");
      value = value.replace(regex, ` ${keyword} `);
    });
    return value;
  };

  const normalizeSegment = (segment) => {
    const spaced = addKeywordSpacing(segment)
      .replace(/([A-Za-z])(\d)/g, "$1 $2") // letter-digit
      .replace(/(\d)([A-Za-z])/g, "$1 $2") // digit-letter
      .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase boundaries
      .replace(/\s+/g, " ")
      .trim();
    return toTitleCase(spaced);
  };

  return addr
    .split(",")
    .map((part) => normalizeSegment(part.trim()))
    .filter(Boolean)
    .join(", ");
};
